var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center align-center"},[_vm._m(0),_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../../assets/logo.png")}})])
}]

export { render, staticRenderFns }